<template>
  <div>
    <div id="logout-sso-screen">
      <div class="background">
        <img src="@/assets/imgs/header.png">
      </div>
      <div class="d-flex align-items-center justify-content-center flex-column card-logout-sso">
        <div class="check-container">
          <font-awesome-icon icon="check" class="check-ok"/>
        </div>
        <h1>Você foi desconectado com sucesso</h1>
        <p>Obrigado</p>
      </div>
    </div>
  </div>
</template>
<script>

  export default {
    components: {
    },
    data() {
      return {
        client_id: null,
        access_token: null,
        loading: false,
      };
    },
    methods: {
    },
    mounted() {
      this.client_id = this.$route.query.client_id;
      this.access_token = this.$route.query.access_token;
      setTimeout(() => {
        this.$root.logout();
      }, 3300);
    },
  };
</script>

<style scoped>
#logout-sso-screen{
  display:flex;
  justify-content:center;
  align-items:center;
  height:100vh;
  width:100vw;
}
.background{z-index:-1;position:absolute;width:100vw;height:100vh;overflow: hidden;background:linear-gradient(180deg, #1ACEB5 0%, #4780F1 100%) 0% 0% no-repeat padding-box;}
.background img {width: 100%;height: 100%;object-fit: cover;mix-blend-mode: multiply;}

h1{
  font: normal normal bold 18px/20px  'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #597EB5;
  text-align: center;
  margin-bottom: 24px;
}
p{
  text-align: center;
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
}
.card-logout-sso {
  padding: 38px 38px 38px 37px;
  box-shadow: 4px 6px 20px -3px #00000063;
  border-radius: 7px;
  background-color:#FFF;
  width: 453px;
}
.check-ok{
  font-size:38px;
  padding:15px;
  border: 3px solid #8ac89b;
  border-radius: 100%;
  color: #5bac71;
}
.check-container{
  display: flex;
  width: 100%;
  justify-content: center;
  align-content: center;
  gap: 22px;
  margin-top: 50px;
  margin-bottom: 45px;
}
  .check-container:before, .check-container:after {
    content: '';
    width: 100%;
    height: 1px;
    background: #c3c3c3;
    margin: auto;
  }

</style>